export default {
  drawer: false,
  color: 'success',
  image: '',
  isControl: true,
  accessSySafra: false,
  accessSocketControls: false,
  redirectToControl() { window.location.href = '/dashboard'; },
  title: '',
};
